export default {
  getRestaurantAdmin: (state) => state.restaurantAdmin,
};
